import { BILLING_API } from '@Constants/backendConstants';
import { Permission } from '@Constants/Permission.g';
import { useHasPermission } from '@Contexts/appContext';
import { type ApiInvoice } from '@Model';
import {
    FrameFallback,
    type IFrameEditShellProps,
    useEditFrame,
    useFrameEditBaseNavigation,
} from '@synqo/frontend-component-library';
import { useMemo } from 'react';
import { useParams } from 'react-router';
import { InvoiceFrameBody } from './Invoice/InvoiceFrameBody';

// @ai-generated 2026-09-18T07:55:12+00:00 by philipp.kammerer@synqony.com using Claude Opus 5

export function FrameEditInvoice(props: IFrameEditShellProps<ApiInvoice>) {
    const { itemId } = useParams();
    const primaryKey = props.primaryKey ?? itemId ?? '';

    return (
        <InvoiceEditFrame
            key={primaryKey}
            {...props}
            primaryKey={primaryKey}
            embedded={props.embedded || props.primaryKey !== undefined}
        />
    );
}

function InvoiceEditFrame(props: IFrameEditShellProps<ApiInvoice> & { primaryKey: string }) {
    const hasPermission = useHasPermission();
    const primaryKey = props.primaryKey;

    const frameEditBaseNavigationEvents = useFrameEditBaseNavigation();

    const events = useMemo(
        () => ({
            ...frameEditBaseNavigationEvents,
            ...props.events,
        }),
        [frameEditBaseNavigationEvents, props.events],
    );

    const frame = useEditFrame<ApiInvoice>({
        apiResourcePath: `${BILLING_API}/invoices`,
        primaryKey,
        embedded: props.embedded,
        events,
        canEdit: props.canEdit !== false && hasPermission(Permission.BillingInvoicesUpdate),
        canCreate: props.canCreate !== false && hasPermission(Permission.BillingInvoicesCreate),
        canDelete: props.canDelete !== false && hasPermission(Permission.BillingInvoicesDelete),
    });

    if (frame.status !== 'ready') {
        return <FrameFallback frame={frame} />;
    }

    return <InvoiceFrameBody key={frame.recordId} frame={frame} />;
}
